var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowToRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2925 9.39056C11.9025 9.78056 11.9025 10.4106 12.2925 10.8006L16.1725 14.6806L12.2925 18.5606C11.9025 18.9506 11.9025 19.5806 12.2925 19.9706C12.6825 20.3606 13.3125 20.3606 13.7025 19.9706L18.2925 15.3806C18.6825 14.9906 18.6825 14.3606 18.2925 13.9706L13.7025 9.38056C13.3225 9.00056 12.6825 9.00056 12.2925 9.39056Z",
    fill: "#ADB8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToRight);
export default __webpack_public_path__ + "static/media/ArrowToRight.91fae14723f12b151e158a20cc0371b6.svg";
export { ForwardRef as ReactComponent };